import { RefreshCcw01, Trash02 } from "@untitledui/icons";
import { ButtonUtility } from "@/components/base/buttons/button-utility";
import { type ComposerImage, formatImageSize } from "./composer-image";

type ImageAttachmentProps = {
  image: ComposerImage;
  onReplace: () => void;
  onRemove: () => void;
  disabled?: boolean;
};

export function ImageAttachment({ image, onReplace, onRemove, disabled }: ImageAttachmentProps) {
  return (
    <div className="flex items-center gap-3 rounded-xl border border-secondary bg-secondary p-2">
      <img
        src={image.previewUrl}
        alt=""
        className="size-14 shrink-0 rounded-lg border border-secondary bg-primary object-cover"
      />
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <p className="truncate text-sm font-medium text-primary">{image.name}</p>
        {image.size !== undefined && <p className="text-xs text-quaternary">{formatImageSize(image.size)}</p>}
      </div>
      <div className="flex shrink-0 items-center gap-1">
        <ButtonUtility
          tooltip="Replace image"
          icon={RefreshCcw01}
          color="tertiary"
          size="xs"
          isDisabled={disabled}
          onClick={onReplace}
        />
        <ButtonUtility
          tooltip="Remove image"
          icon={Trash02}
          color="tertiary"
          size="xs"
          isDisabled={disabled}
          onClick={onRemove}
        />
      </div>
    </div>
  );
}
